import { createAction } from "redux-act";

export const OpenNewPlaygroundGroupModalAction = createAction("Playground Group - Open New Modal");
export const CloseNewPlaygroundGroupModalAction = createAction("Playground Group - Close New Modal");

export const PlaygroundGroupNewAction = createAction("Playground Group New");
export const PlaygroundGroupNewRequestAction = createAction("Playground Group New - Request");
export const PlaygroundGroupNewSuccessAction = createAction("Playground Group New - Success");
export const PlaygroundGroupNewFailedAction = createAction("Playground Group New - Failed");
